import { SearchResponse } from '@/interfaces/Search'
import { AxiosPromise } from 'axios'
import { client } from '.'

export function search(query: string): AxiosPromise<SearchResponse> {
  return client.get('/search', {
    params: {
      query,
    },
  })
}
